export interface ProductPrice {
  basePrice?: number | null | undefined;
  discountedPrice?: number | null | undefined;
}
interface ProductPriceRange {
  minPrice: number;
  maxPrice: number;
}

/* Returns the price of the least and most expensive products in a list */
const getProductListPriceRange = (
  productPrices: ProductPrice[],
): ProductPriceRange | null => {
  const prices = productPrices
    .map(({ basePrice, discountedPrice }) =>
      basePrice != null &&
      discountedPrice != null &&
      basePrice > discountedPrice
        ? discountedPrice
        : basePrice,
    )
    .filter((finalPrice): finalPrice is number => finalPrice != null);

  if (prices.length === 0) {
    return null;
  }

  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  return { minPrice, maxPrice };
};

export default getProductListPriceRange;
